export const isEmptyClipboard = (e: Pick<ClipboardEvent, 'clipboardData'>) => {
  const selection = globalThis.getSelection();
  return e.clipboardData === null || (selection?.toString().length ?? 0) <= 0;
};
